import * as Yup from "yup";
/* eslint-disable no-useless-escape */
const ChangePasswordValidation = (t) => {
  return Yup.object().shape({
    oldPassword: Yup.string().required(),
    newPassword: Yup.string()
      .min(8)
      .required()
      .matches(/\p{Ll}/u)
      .matches(/[A-Z]/)
      .matches(/[0-9]/)
      .matches(/[\^$*.{}\[\]()?"!@#%&/\\,><':;|_~`=+\-]/),
    newPasswordConfirm: Yup.string().oneOf(
      [Yup.ref("newPassword")],
      t("forgotPassword.passwordError")
    ),
  });
};
export default ChangePasswordValidation;
